import './App.css';

import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';


import Home from "./components/pages/Home";
import Footer from "./components/inc/Footer";
import Roompage from './components/pages/Roompage';
import Contactus from './components/pages/Contactus';
import Aboutpage from './components/pages/Aboutpage';
import Seminarpage from './components/pages/Seminarpage';

function App() {
  return (
     <Router>
    
    <div>

     
      
      <Routes>

      <Route axact path="/" element={<Home/>}/>
      <Route axact path="/room" element={<Roompage/>}/>
       <Route axact path="/contact-us" element={<Contactus/>}/>
           <Route axact path="/aboutus" element={<Aboutpage/>}/>
               <Route axact path="/seminar" element={<Seminarpage/>}/>
            
      </Routes>
    <Footer/>
  
    </div>

    </Router>
  );
}

export default App;
